import { fetchWrapper } from '../../utils/request';
import { endpoint } from './endpoint';

export async function getNotifications() {
  return fetchWrapper(endpoint + `/v1/dashboard/notifications`, {
    method: 'get',
  }).then((res) => res.json());
}

export async function getRejectNotifications() {
  return fetchWrapper(endpoint + `/v1/dashboard/reject-notifications`, {
    method: 'get',
  }).then((res) => res.json());
}

export async function viewNotification(id) {
  return fetchWrapper(endpoint + `/v1/dashboard/viewed-request/${id}`, {
    method: 'put',
    body: JSON.stringify({ id }),
  });
}

export async function getJourney() {
  return fetchWrapper(endpoint + `/v1/dashboard/journey`, {
    method: 'get',
  }).then((res) => res.json());
}

export async function getAnalytics() {
  return fetchWrapper(endpoint + `/v1/dashboard-analytics`, {
    method: 'get',
  }).then((res) => res.json());
}

export async function getSalesOrders() {
  return fetchWrapper(endpoint + `/v1/shopify/orders`, {
    method: 'get',
  }).then((res) => res.json());
}
